import React from 'react';

import { Botao } from '../../../';

function OkAction({ onClose, children }) {
  return <Botao onClick={onClose}>{children}</Botao>;
}

export default OkAction;
